import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Setting basename to the deployment folder for the Tracker App */}
    <BrowserRouter basename="/trumptracker"> 
      <App />
    </BrowserRouter>
  </React.StrictMode>
);